import PropTypes from "prop-types";
import React from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate  } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { loginUser, loginSuccess, apiError } from "../../store/actions"; // Import actions
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo.svg";

const Login = (props) => {

  document.title = "Login";
  const navigate = useNavigate();
 const baseurl = process.env.REACT_APP_BASE_URL;
  document.title = "Login"; // Set page title

  const dispatch = useDispatch();
  const user = useSelector((state) => state.Login.user); // Access the user data from the Redux store
  const isLoading = useSelector((state) => state.Login.loading); // Access loading state
  const error = useSelector((state) => state.Login.error); // Access any error message

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "admin@gmail.com",
      password: "123456",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      // Dispatch loginUser to set loading state
      dispatch(loginUser());

      try {
        const response = await fetch(baseurl + "/admin/login", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(values),
        });

        if (!response.ok) {
          const errorData = await response.json();
          // Dispatch apiError if the API returns an error
          dispatch(apiError(errorData.error || "An error occurred. Please try again."));
          throw new Error(errorData.error || "An error occurred. Please try again.");
        }

        const data = await response.json();
        const { token,permissions, admin } = data;

        // Dispatch loginSuccess to save token and user data
        dispatch(loginSuccess(token, admin));

        localStorage.setItem("authToken", token);
         localStorage.setItem("authUser", JSON.stringify(admin));
         const permissionKeys = permissions.map(p => p.permission_key);
  localStorage.setItem("permissions", JSON.stringify(permissionKeys));
       

        navigate("/"); // Redirect after successful login
      } catch (error) {
        dispatch(apiError(error.message)); // Dispatch apiError if exception occurs
      }
    },
  });

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back!</h5>
                        <p>Sign in to continue to Ecommerce.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img src={logo} alt="" className="rounded-circle" height="34" />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                      }}
                    >
                      {error && <Alert color="danger">{error.message || error}</Alert>} {/* Show error alert if error exists */}

                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email}
                          invalid={validation.touched.email && validation.errors.email}
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password}
                          invalid={validation.touched.password && validation.errors.password}
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label className="form-check-label" htmlFor="customControlInline">
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button className="btn btn-primary btn-block" type="submit" disabled={isLoading}>
                          {isLoading ? "Logging In..." : "Log In"}
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login;

Login.propTypes = {
  history: PropTypes.object,
};
